/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  actions: [],
};

const formActionsSlice = createSlice({
  name: 'actions',
  initialState,
  reducers: {
    setActions(state, action) {
      state.actions = action.payload;
    },
    updateActions(state, action) {
      state.actions = action.payload;
    },
  },
});
export default formActionsSlice.reducer;

export const {
  setActions,
  updateActions,
} = formActionsSlice.actions;

export const getActions = (state) => state.actions.actions;
